export enum SessionServiceKeys {
  HIDE_OLD_UI_POPUP = 'hideOldUIPopup',
}
